import * as types from './constants';

// Update Lookbook OrderItem
export const updateLookbookOrderItemRequest = data => (
  { type: types.UPDATE_LOOKBOOK_ORDER_ITEM_REQUEST, payload: data }
);

export const updateLookbookOrderItemDone = data => (
  { type: types.UPDATE_LOOKBOOK_ORDER_ITEM_DONE, payload: data }
);

export const updateLookbookOrderItemFailed = errors => (
  { type: types.UPDATE_LOOKBOOK_ORDER_ITEM_FAILED, payload: errors }
);

export const updateLookbookOrderItemClearErrors = prop => (
  { type: types.UPDATE_LOOKBOOK_ORDER_ITEM_CLEAR_ERRORS, payload: prop }
);

export const updateLookbookOrderItemReset = () => (
  { type: types.UPDATE_LOOKBOOK_ORDER_ITEM_RESET }
);
